import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Modal from "@material-ui/core/Modal"
import Fade from "@material-ui/core/Fade"
import CustomButton from "../form-components/custom-button"

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: 12,
    outline: "none",
    // @ts-ignore
    width: (props) => (props.size === "medium" ? "500px" : props.size === "large" ? "90vw" : "700px"),
    maxWidth: "95vw",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
  },
  modalContent: {
    padding: theme.spacing(2, 4, 0),
    overflow: "auto",
    flex: 1,
  },
  buttonContainer: {
    padding: theme.spacing(2, 4, 3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap", // Prevent wrapping
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  rightButtonGroup: {
    display: "flex",
    flexWrap: "nowrap", // Prevent wrapping
    alignItems: "center",
  },
  secondaryButton: {
    marginLeft: "10px", // More compact spacing
  },
}))

export default function CustomModal({
  showModal,
  size,
  title,
  children,
  onCloseModal,
  onSubmit = undefined,
  cancelBtnDisabled = false,
  cancelBtnText = "Cancel",
  submitBtnText = "Submit",
  submitBtnDisabled = false,
  loading = false,
  secondaryRightBtnText = undefined,
  onSecondaryRightBtnSubmit = undefined,
  secondaryBtnLoading = undefined,
}) {
  const classes = useStyles({ size })

  return (
    <Modal
      className={classes.modal}
      open={showModal}
      onClose={onCloseModal}
      closeAfterTransition
      disableBackdropClick
    >
      <Fade in={showModal}>
        <div className={classes.paper}>
          <div className={classes.modalContent}>
            {title && <h2 id="transition-modal-title">{title}</h2>}
            <div>{children}</div>
          </div>
          <div className={classes.buttonContainer}>
            <CustomButton
              variant="link"
              onClick={onCloseModal}
              style={undefined}
              disabled={cancelBtnDisabled}
            >
              {cancelBtnText}
            </CustomButton>
            <div className={classes.rightButtonGroup}>
              {/* Only render submit button if submitBtnText and onSubmit are provided */}
              {submitBtnText && onSubmit && (
                <CustomButton
                  onClick={onSubmit}
                  style={undefined}
                  disabled={submitBtnDisabled}
                  loading={loading}
                >
                  {submitBtnText}
                </CustomButton>
              )}
              {secondaryRightBtnText && (
                <span className={classes.secondaryButton}>
                  <CustomButton
                    onClick={onSecondaryRightBtnSubmit}
                    style={undefined}
                    disabled={secondaryBtnLoading}
                    loading={secondaryBtnLoading}
                  >
                    {secondaryRightBtnText}
                  </CustomButton>
                </span>
              )}
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  )
}